(function(){
  'use strict';
  var root = document.documentElement;

  /* ---------------- natural droplet sound (synthesised, no audio files) ---------------- */
  var audioCtx;
  function playDrop(baseFreq, dur){
    try{
      if(!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      if(audioCtx.state === 'suspended') audioCtx.resume();
      var now = audioCtx.currentTime;
      var osc = audioCtx.createOscillator();
      var g = audioCtx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(baseFreq * 1.8, now);
      osc.frequency.exponentialRampToValueAtTime(Math.max(60, baseFreq * 0.6), now + dur);
      g.gain.setValueAtTime(0.0001, now);
      g.gain.exponentialRampToValueAtTime(0.05, now + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
      osc.connect(g).connect(audioCtx.destination);
      osc.start(now);
      osc.stop(now + dur + 0.02);
    }catch(e){}
  }
  var lastSound = 0;
  function playClick(){
    var t = Date.now();
    if(t - lastSound < 60) return;
    lastSound = t;
    playDrop(480 + Math.random() * 120, 0.13);
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('a, button, .dye-chip, .chip-btn, .product, .thumb, .swatch-opt')) playClick();
  }, true);

  /* ---------------- theme toggle (light/dark) ---------------- */
  var themeToggle = document.getElementById('theme-toggle');
  if(themeToggle){
    var stored = window.localStorage ? localStorage.getItem('lallari-theme') : null;
    if(stored) root.setAttribute('data-theme', stored);
    themeToggle.addEventListener('click', function(){
      var current = root.getAttribute('data-theme');
      var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      var isDark = current ? current === 'dark' : prefersDark;
      var next = isDark ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      root.setAttribute('data-mode', next);
      if(window.localStorage) localStorage.setItem('lallari-theme', next);
      playDrop(isDark ? 640 : 300, 0.22);
      var sun = themeToggle.querySelector('.sun');
      var moon = themeToggle.querySelector('.moon');
      if(sun && moon){
        sun.style.display = next === 'dark' ? 'none' : 'block';
        moon.style.display = next === 'dark' ? 'block' : 'none';
      }
    });
  }

  /* ---------------- sticky nav shadow ---------------- */
  var nav = document.getElementById('site-nav');
  if(nav){
    window.addEventListener('scroll', function(){
      nav.classList.toggle('is-scrolled', window.scrollY > 8);
    }, {passive:true});
  }

  /* ---------------- mobile menu ---------------- */
  var menuToggle = document.getElementById('menu-toggle');
  var navLinks = document.getElementById('nav-links');
  if(menuToggle && navLinks){
    if(!navLinks.id){ navLinks.id = 'nav-links'; }
    menuToggle.setAttribute('aria-controls', navLinks.id);
    menuToggle.setAttribute('aria-expanded', 'false');

    var setMenu = function(open){
      navLinks.classList.toggle('is-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    menuToggle.addEventListener('click', function(e){
      e.stopPropagation();
      setMenu(!navLinks.classList.contains('is-open'));
    });

    navLinks.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ setMenu(false); });
    });

    /* Tap anywhere off the panel to dismiss. */
    document.addEventListener('click', function(e){
      if(!navLinks.classList.contains('is-open')) return;
      if(navLinks.contains(e.target) || menuToggle.contains(e.target)) return;
      setMenu(false);
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && navLinks.classList.contains('is-open')){
        setMenu(false);
        menuToggle.focus();
      }
    });

    /* Don't leave the panel open when rotating/resizing up to desktop. */
    window.addEventListener('resize', function(){
      if(window.innerWidth > 800 && navLinks.classList.contains('is-open')) setMenu(false);
    });

    /* Submenu accordions. Desktop opens these on hover via CSS, so the chevron
       buttons are only interactive at mobile widths. */
    navLinks.querySelectorAll('.nav-sub-toggle').forEach(function(btn){
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if(!sub) return;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var open = !sub.classList.contains('is-open');
        sub.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Collapse every accordion whenever the mobile panel closes, so it reopens clean. */
    navLinks.addEventListener('transitionend', function(){
      if(navLinks.classList.contains('is-open')) return;
      navLinks.querySelectorAll('.nav-sub.is-open').forEach(function(sub){
        sub.classList.remove('is-open');
      });
      navLinks.querySelectorAll('.nav-sub-toggle[aria-expanded="true"]').forEach(function(b){
        b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------------- scroll reveal ---------------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduceMotion && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {threshold:.12, rootMargin:'0px 0px -50px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---------------- hero vat: tilt toward cursor ---------------- */
  var vatPanel = document.getElementById('vat-panel');
  if(vatPanel && !reduceMotion){
    vatPanel.addEventListener('mousemove', function(e){
      var r = vatPanel.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      vatPanel.style.transform = 'perspective(900px) rotateX(' + (py * -8) + 'deg) rotateY(' + (px * 10) + 'deg)';
    });
    vatPanel.addEventListener('mouseleave', function(){
      vatPanel.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
    });
  }

  /* ---------------- collection: sort redirect ---------------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if(sortSelect){
    sortSelect.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---------------- product page: gallery + variant + cart ---------------- */
  var productForm = document.querySelector('[data-product-form]');
  if(productForm){
    var galleryMain = document.getElementById('gallery-main');
    var galleryImg = document.getElementById('gallery-main-img');
    var galleryLabel = document.getElementById('gallery-label');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var variantIdInput = productForm.querySelector('[data-variant-id]');

    function setGallery(full, label){
      if(!galleryMain) return;
      if(galleryImg){ galleryImg.src = full; }
      if(galleryLabel){ galleryLabel.textContent = label; }
      thumbs.forEach(function(t){ t.classList.toggle('is-active', t.dataset.full === full); });
    }
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){ setGallery(t.dataset.full, t.dataset.label); });
    });
    if(galleryMain && thumbs.length){
      galleryMain.addEventListener('click', function(){
        var list = Array.prototype.slice.call(thumbs);
        var idx = list.findIndex(function(t){ return t.classList.contains('is-active'); });
        var next = list[(idx + 1) % list.length];
        setGallery(next.dataset.full, next.dataset.label);
      });
    }

    // variant option selection (swatch buttons + native selects) -> find matching variant via product JSON
    var productJsonEl = document.getElementById('product-json-' + (productForm.dataset.productId || ''));
    var productData = null;
    try{ if(productJsonEl) productData = JSON.parse(productJsonEl.textContent); }catch(e){}

    var selectedOptions = [];
    document.querySelectorAll('[data-option-index]').forEach(function(el){
      var idx = parseInt(el.dataset.optionIndex, 10);
      var current = el.tagName === 'SELECT' ? el.value : (el.classList.contains('is-active') ? el.dataset.optionValue : null);
      if(current) selectedOptions[idx] = current;
    });

    function updateVariant(){
      if(!productData) return;
      var match = productData.variants.find(function(v){
        return v.options.every(function(opt, i){ return selectedOptions[i] == null || opt === selectedOptions[i]; });
      });
      if(match && variantIdInput){
        variantIdInput.value = match.id;
        var addBtn = productForm.querySelector('[data-add-to-cart]');
        if(addBtn){
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
        }
        var priceEl = document.querySelector('.buy-price');
        if(priceEl && match.price != null){
          var money = (match.price / 100).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
          var priceNode = priceEl.childNodes[0];
        }
        if(match.featured_image){
          setGallery(match.featured_image.src, match.public_title || match.title);
        }
      }
    }

    document.querySelectorAll('.swatch-opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        var idx = parseInt(btn.dataset.optionIndex, 10);
        var group = document.querySelectorAll('.swatch-opt[data-option-index="' + idx + '"]');
        group.forEach(function(b){ b.classList.toggle('is-active', b === btn); });
        selectedOptions[idx] = btn.dataset.optionValue;
        var currentLabel = document.querySelector('[data-option-current="' + idx + '"]');
        if(currentLabel) currentLabel.textContent = btn.dataset.optionValue;
        updateVariant();
      });
    });
    document.querySelectorAll('select.variant-select').forEach(function(sel){
      sel.addEventListener('change', function(){
        var idx = parseInt(sel.dataset.optionIndex, 10);
        selectedOptions[idx] = sel.value;
        var currentLabel = document.querySelector('[data-option-current="' + idx + '"]');
        if(currentLabel) currentLabel.textContent = sel.value;
        updateVariant();
      });
    });

    // quantity stepper
    var qtyInput = productForm.querySelector('[data-qty-input]');
    var qtyMinus = productForm.querySelector('[data-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-qty-plus]');
    if(qtyInput && qtyMinus && qtyPlus){
      qtyMinus.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
      qtyPlus.addEventListener('click', function(){ qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1); });
    }

    // AJAX add to cart
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var note = productForm.querySelector('[data-buy-note]');
      var btn = productForm.querySelector('[data-add-to-cart]');
      var formData = new FormData(productForm);
      if(btn) btn.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(res){ return res.json(); })
      .then(function(data){
        if(data.status){
          if(note) note.textContent = data.description || 'Could not add that to your bag.';
          if(btn) btn.disabled = false;
          return;
        }
        if(note) note.textContent = 'Added to your bag.';
        if(btn) btn.disabled = false;
        refreshCart();
        openCart();
      })
      .catch(function(){
        if(note) note.textContent = 'Something went wrong — try again.';
        if(btn) btn.disabled = false;
      });
    });
  }

  /* ---------------- cart drawer ---------------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOverlay = document.getElementById('cart-overlay');
  var cartCount = document.getElementById('cart-count');

  function openCart(){
    if(cartDrawer){ cartDrawer.classList.add('is-open'); }
    if(cartOverlay){ cartOverlay.classList.add('is-open'); }
  }
  function closeCart(){
    if(cartDrawer){ cartDrawer.classList.remove('is-open'); }
    if(cartOverlay){ cartOverlay.classList.remove('is-open'); }
  }
  document.querySelectorAll('[data-cart-toggle]').forEach(function(el){
    el.addEventListener('click', function(){
      if(cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
      else openCart();
    });
  });

  function refreshCart(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res){ return res.json(); })
      .then(function(cart){
        if(cartCount){
          cartCount.textContent = cart.item_count;
          cartCount.hidden = cart.item_count === 0;
        }
        var body = document.getElementById('cart-drawer-body');
        if(!body) return;
        if(cart.item_count === 0){
          body.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
          return;
        }
        var html = cart.items.map(function(item, i){
          var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
          var variantLine = item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-line-variant">' + item.variant_title + '</p>' : '';
          var money = (item.final_line_price / 100).toLocaleString(undefined, {style:'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'});
          return '<div class="cart-line" data-line="' + (i + 1) + '">' + img +
            '<div><p class="cart-line-title">' + item.product_title + '</p>' + variantLine +
            '<p class="cart-line-variant">Qty ' + item.quantity + '</p>' +
            '<button class="cart-line-remove" data-cart-remove="' + (i + 1) + '">Remove</button></div></div>';
        }).join('');
        body.innerHTML = html;
        var subtotal = document.querySelector('.cart-subtotal span:last-child');
        if(subtotal){
          subtotal.textContent = (cart.total_price / 100).toLocaleString(undefined, {style:'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'});
        }
      });
  }

  document.addEventListener('click', function(e){
    var removeBtn = e.target.closest('[data-cart-remove]');
    if(!removeBtn) return;
    var line = removeBtn.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function(){ refreshCart(); });
  });


  /* ---------------- announcement bar ---------------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var key = bar.getAttribute('data-announcement-key');

    /* Dismissed? Leave it hidden. Storage can throw in private mode. */
    if (key) {
      try { if (window.localStorage.getItem(key) === '1') return; } catch (e) {}
    }

    bar.hidden = false;

    var close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', function () {
        bar.hidden = true;
        if (key) { try { window.localStorage.setItem(key, '1'); } catch (e) {} }
      });
    }

    var items = bar.querySelectorAll('[data-announcement-item]');
    var interval = parseInt(bar.getAttribute('data-announcement-rotate'), 10);
    if (items.length < 2 || !interval) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var i = 0;
    var timer = setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
      items[i].removeAttribute('aria-hidden');
    }, interval);

    /* Don't rotate text out from under someone reading or tabbing through it. */
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('focusin', function () { clearInterval(timer); });
  });

})();
